/*
 *  ZAITEC CONFIDENTIAL
 *  __________________
 *
 * [2019] - [2020] zaiTEC Logixs Ltd
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of  zaiTEC Logixs Ltd and its suppliers,if any.
 *  The intellectual and technical concepts contained herein are proprietary to zaiTEC Logixs Ltd, and are protected by
 *  trade secret or copyright law.Dissemination of this information or reproduction of this material is strictly forbidden
 *  unless prior written permission is obtained from  zaiTEC Logixs Ltd.
 */

import { Pipe, PipeTransform } from '@angular/core';
import {MetaData} from '../model/metadata';
@Pipe({
  name: 'matchesCategory'
})
export class DropDownFilterPipe implements PipeTransform {
   transform(metadatList: Array<MetaData> | null | undefined, category: string | null | undefined): Array<MetaData> {
    // If metadatList is null/undefined or not an array, return an empty array
    if (!metadatList || !Array.isArray(metadatList)) {
      return [];
    }

    // If category is null/undefined or empty, return the full list (no filtering)
    if (!category || category.trim() === '') {
      return metadatList;
    }
    return metadatList.filter(metadata => metadata.categ === category);
  }
}